module.exports = __webpack_public_path__ + "img/new_team.d76e86c6.svg";